import { useState } from "react";

const today = () => new Date().toISOString().slice(0, 10);

export default function CloseForm({ position, onCancel, onDone, onClose }) {
  const [price, setPrice] = useState(position.currentPrice ? String(position.currentPrice.toFixed(2)) : "");
  const [date, setDate] = useState(today());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await onClose(position.id, { exitPrice: Number(price), exitDate: date });
      onDone();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="mark-entered" onSubmit={submit}>
      <p className="mark-entered-title">Record your sale of {position.symbol}</p>
      <div className="mark-entered-fields">
        <label className="field">
          <span>Price you sold at</span>
          <input type="number" step="0.01" min="0.01" required autoFocus value={price} onChange={(e) => setPrice(e.target.value)} />
        </label>
        <label className="field">
          <span>Date</span>
          <input type="date" required max={today()} value={date} onChange={(e) => setDate(e.target.value)} />
        </label>
      </div>
      {error && <p className="mark-entered-error" role="alert">{error}</p>}
      <div className="mark-entered-actions">
        <button type="submit" className="btn primary" disabled={busy}>{busy ? "Saving…" : "Save"}</button>
        <button type="button" className="btn" onClick={onCancel} disabled={busy}>Cancel</button>
      </div>
    </form>
  );
}
